/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_TitleInputs */

const en_gc_search_guides_gridcraft_online_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft Online: Open a Spreadsheet and Save Your Work`)
};

const zh_gc_search_guides_gridcraft_online_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 在线使用：打开电子表格并保存文件`)
};

/**
* | output |
* | --- |
* | "GridCraft Online: Open a Spreadsheet and Save Your Work" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_title(inputs)
	return zh_gc_search_guides_gridcraft_online_title(inputs)
});
export { gc_search_guides_gridcraft_online_title as "gc.search_guides.gridcraft_online.title" }